import Immutable from 'immutable';
import Cookies from 'cookies-js';
import moment from 'moment';

import ActionStatus from '../constants/ActionStatus';
import env from '../helpers/env';
import { toJSON, genAction, genFetchOptions, proxy } from '@mdf/cube/lib/helpers/util';
import { getMenuTree, clearMenu } from './tree';
import { addItem, clear } from './tabs';
//import { getLayOut, clearLayOut } from './home';

const user = {
  usernameMsg: '',
  passwordMsg: '',
  errorMsg: '',
  id: null,
  username: null,
  password: null,
  corp_id: null,
  pubuts: null,
  bActivate: null,
  bEmailValid: null,
  bMobileValid: null,
  mobile: null,
  salt: null,
  iDeleted: null,
  bCorpRegister: false,
  dataSourceName: null,
  alias: null,
  token: null,
  accountCurrentKey: 'personalInfo',
  enableLogin: (process.env.NODE_ENV === 'development') ?
    true : false
};

const $$initialState = Immutable.fromJS({
  // 用户属性
  ...user,
  // 登陆状态
  loginStatus: ActionStatus.READY
});

export default (state = $$initialState, action) => {
  switch (action.type) {
    case 'PLATFORM_UI_USER_INIT':
      if (process.env.__CLIENT__) {
        const loginUserBackup = state.get('loginUserBackup');
        if (!loginUserBackup)
          return state;
        const loginUser = loginUserBackup.toJS();
        cb.rest.AppContext.tenant = loginUser.tenant;
        delete loginUser.tenant;
        cb.rest.AppContext.option = loginUser.option;
        delete loginUser.option;
        cb.rest.AppContext.user = loginUser;
        return state;
      }
      buildUser(action.payload);
      return state.merge(action.payload);
    case 'PLATFORM_DATA_USER_LOGIN':
      return state.set('loginStatus', ActionStatus.ING);
    case 'PLATFORM_DATA_USER_LOGIN_SUCCEED':
      buildUser(action.payload);
      return state
        .set('loginStatus', ActionStatus.SUCCEED)
        .set('errorMsg', '')
        .merge(action.payload);
    case 'PLATFORM_DATA_USER_LOGIN_FAILURE':
      return state
        .set('loginStatus', ActionStatus.FAILURE)
        .merge(action.payload);
    case 'PLATFORM_DATA_LOGIN_OUT':
      Cookies.expire('user');
      let nullData = {
        id: null,
        username: null,
        password: null,
        corp_id: null,
        pubuts: null,
        bActivate: null,
        bEmailValid: null,
        bMobileValid: null,
        mobile: null,
        salt: null,
        iDeleted: null,
        bCorpRegister: null,
        dataSourceName: null,
        alias: null,
        token: null,
      };
      return state
        .merge({ ...nullData, loginStatus: ActionStatus.READY });
    case 'PLATFORM_DATA_USER_ACCOUNT_SET_ACCOUNT_MSG':
      return state.merge(action.payload)
    case 'PLATFORM_DATA_USER_ACCOUNT_SET_ACCOUNT_ACTIVE_KEY':
      return state.set('accountCurrentKey', action.payload)
    case 'PLATFORM_DATA_USER_ACCOUNT_CHANGE_ORG':
      return state.merge(action.payload);
    case 'PLATFORM_DATA_USER_ACCOUNT_CHANGE_STORE':
      return state.merge(action.payload);
    case 'PLATFORM_DATA_USER_ACCOUNT_CHANGE_GRADE':
      return state.merge(action.payload);
    case 'PLATFORM_DATA_USER_ACCOUNT_MERGE_INFO':
      return state.merge(action.payload);
    case 'PLATFORM_DATA_CORP_SYSTEMSET_PASS_LOGO':
      return state.merge(action.payload);
    default:
      return state;
  }
}

const buildUser = (user) => {
  const { userOrgs, userStores, orgId, storeId } = user;
  let defaultOrgName, defaultStoreName;
  userOrgs && userOrgs.forEach(item => {
    if (item.org == orgId)
      defaultOrgName = item.org_name;
  });
  userStores && userStores.forEach(item => {
    if (item.store == storeId)
      defaultStoreName = item.store_name;
  })
  Object.assign(user, {
    defaultOrgName: defaultOrgName,
    defaultStoreName: defaultStoreName
  });
  user.loginUserBackup = JSON.parse(JSON.stringify(user));
};

export function usernameChange(value, usernameMsg) {
  return (dispatch) => {
    if (value && usernameMsg)
      dispatch(genAction('PLATFORM_DATA_USER_LOGIN_FAILURE', { usernameMsg: '' }));
  }
}

export function passwordChange(value, passwordMsg) {
  return (dispatch) => {
    if (value && passwordMsg)
      dispatch(genAction('PLATFORM_DATA_USER_LOGIN_FAILURE', { passwordMsg: '' }));
  }
}

const clearCache = () => {
  localStorage.removeItem('defaultGrade');
  localStorage.removeItem('billing_lastBill');
  localStorage.removeItem('billing_lastBillId');
  localStorage.removeItem('billing_printTemplate');
}

//登录
export function login(data) {
  return async (dispatch) => {
    dispatch(genAction('PLATFORM_DATA_USER_LOGIN'));
    if (process.env.NODE_ENV !== 'development' || data.username) {
      let usernameMsg = null, passwordMsg = null;
      if (!data.username)
        usernameMsg = '登录账号不能为空';
      if (!data.password)
        passwordMsg = '密码不能为空';
      if (usernameMsg || passwordMsg) {
        dispatch(genAction('PLATFORM_DATA_USER_LOGIN_FAILURE', {
          usernameMsg,
          passwordMsg
        }));
        return;
      }
    }
    else {
      data.username = 'xmcs001';
      data.password = '123456';
    }
    let config = {
      url: env.HTTP_USER_LOGIN,
      method: 'POST',
      options: { uniform: false, token: false },
      params: data
    };
    let json = await proxy(config);
    console.log(json);
    if (json.code === 200) {
      localStorage.setItem('token', json.data.token);
      cb.rest.ContextBuilder.construct();
      config = {
        url: 'user/getOrgsAndStores',
        method: 'GET',
      };
      json = await proxy(config);
      if (json.code !== 200) {
        dispatch(genAction('PLATFORM_DATA_USER_LOGIN_FAILURE', { errorMsg: json.message }));
        return;
      }
      cb.rest.AppContext.user = json.data;
      config = {
        url: 'tenant/find',
        method: 'GET',
      };
      json = await proxy(config);
      if (json.code === 200)
        cb.rest.AppContext.user.logo = json.data.logo;
      if (env.INTERACTIVE_MODE !== 'touch') {
        dispatch(genAction('PLATFORM_DATA_USER_LOGIN_SUCCEED', cb.rest.AppContext.user));
        cb.route.pushPage('/portal');
      }
      if (json.code === 200)
        cb.rest.AppContext.tenant = json.data;
      config = {
        url: 'option/getOptionData',
        method: 'POST',
        params: {
          optionId: 'sys_option'
        }
      };
      json = await proxy(config);
      const option = {};
      if (json.code === 200)
        Object.assign(option, json.data);
      config = {
        url: 'option/getOptionData',
        method: 'POST',
        params: {
          optionId: 'business_option'
        }
      };
      json = await proxy(config);
      if (json.code === 200)
        Object.assign(option, json.data);
      cb.rest.AppContext.option = option;
      const showOptions = await getMenuTree(dispatch);
      Object.assign(cb.rest.AppContext.user, showOptions);
      dispatch(init(cb.rest.AppContext.user));
      if (data.rememberUser) {
        let rememberAccount = { username: data.username };
        localStorage.setItem('rememberAccount', JSON.stringify(rememberAccount));
      } else {
        if (localStorage.getItem('rememberAccount')) localStorage.removeItem('rememberAccount')
      }
      clearCache();
      if (env.INTERACTIVE_MODE === 'touch') {
        config = {
          url: 'billTemplateSet/getGradeAndEmployee',
          method: 'GET'
        };
        json = await proxy(config);
        if (json.data && json.data.operatorInfo)
          dispatch(genAction('PLATFORM_UI_BILLING_SALES_CLERK_INIT', json.data.operatorInfo));
        config = {
          url: 'billTemplateSet/getBelongTemplate',
          method: 'GET'
        };
        json = await proxy(config);
        if (json.code !== 200) {
          alert(`获取开单设置失败：${json.message}`);
          return;
        }
        dispatch(genAction('PLATFORM_UI_BILLING_CONFIG_INIT', json.data));
        dispatch(genAction('PLATFORM_DATA_USER_LOGIN_SUCCEED', cb.rest.AppContext.user));
        /*add by jinzh1*/
        if (window.plus) plus.JavaToJs.HardwareInterface('onLogin', cb.rest.AppContext.token);
        cb.route.pushPage(showOptions.canBilling ? '/billing' : '/portal');
      }
    }
    else {
      dispatch(genAction('PLATFORM_DATA_USER_LOGIN_FAILURE', { errorMsg: json.message }));
      console.error("错误代码：" + json.code + "错误信息：" + json.message);
    }
  }
}

const afterStoreLoaded = function (showStore) {
  return async function (dispatch) {
    if (showStore !== false)
      dispatch(getGrades());
    dispatch(addItem({
      key: 'PORTAL',
      title: '首页',
      closable: false,
      content: {
        type: 'platform',
        url: 'home'
      }
    }));
   // dispatch(getLayOut());
  }
}

const getGrades = function () {
  return async function (dispatch) {
    const config = {
      url: 'billTemplateSet/getGradeAndEmployee',
      method: 'GET'
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      // cb.utils.alert(json.message, 'error');
      return;
    }
    const userGrades = json.data.gradeInfo;
    // if (!userGrades.length) return;
    dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_MERGE_INFO', { userGrades }));
    const defaultGrade = userGrades.find(item => {
      const { startTime, endTime } = item;
      if (startTime && endTime)
        return moment().isBetween(moment(startTime, 'HH:mm:ss'), moment(endTime, 'HH:mm:ss'));
      return false;
    });
    if (!defaultGrade) {
      cb.utils.alert('没有可用的班次', 'error');
      return;
    }
    dispatch(changeGrade(defaultGrade.id, defaultGrade.name));
  }
}

export function init(loginUser) {
  return function (dispatch, getState) {
    let { userOrgs, userStores, orgId, storeId, showOrg, showStore } = loginUser || getState().user.toJS();
    if (!userOrgs && !userStores && !orgId && !storeId && !showOrg && !showStore) return;
    let defaultOrg, defaultStore;
    if (showOrg) {
      const cacheOrg = localStorage.getItem('defaultOrg');
      if (cacheOrg && cacheOrg != orgId) {
        defaultOrg = userOrgs.find(item => {
          return item.org == cacheOrg;
        });
      }
    }
    if (showStore) {
      const cacheStore = localStorage.getItem('defaultStore');
      if (cacheStore && cacheStore != storeId) {
        defaultStore = userStores.find(item => {
          return item.store == cacheStore;
        });
      }
    }
    if (defaultOrg && defaultStore)
      return dispatch(_changeOrgAndStore(defaultOrg.org, defaultOrg.org_name, defaultStore.store, defaultStore.store_name));
    if (defaultOrg)
      dispatch(changeOrg(defaultOrg.org, defaultOrg.org_name, true));
    if (defaultStore)
      return dispatch(changeStore(defaultStore.store, defaultStore.store_name, true));
    dispatch(afterStoreLoaded(showStore));
  }
}

export function billingInit() {
  return function (dispatch, getState) {
    dispatch(getGrades());
    return;
    const cacheGrade = localStorage.getItem('defaultGrade');
    if (!cacheGrade) return;
    const defaultGrade = JSON.parse(cacheGrade);
    dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_MERGE_INFO', defaultGrade));
  }
}

//登出
export function logout(router) {
  return (dispatch) => {
    // dispatch({
    //   type: 'PLATFORM_DATA_LOGIN_OUT',
    // })
    Cookies.expire('token');
    router.push('/login');
    dispatch(clearMenu());
    dispatch(clear());
    //dispatch(clearLayOut());
  }
}
// 账户中心
export function setAccountMsg(value) {
  return (dispatch) => {
    dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_SET_ACCOUNT_MSG', value));
  }
}

export function setAccountActiveKey(value) {
  return (dispatch) => {
    dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_SET_ACCOUNT_ACTIVE_KEY', value));
  }
}

export function getLoginUser() {
  return function (dispatch) {
    const config = {
      url: 'user/getLoginUserByToken',
      method: 'GET'
    }
    proxy(config)
      .then(json => {
        if (json.code !== 200) return;
        dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_SET_INFO', json.data));
      });
  }
}

export function changeOrg(value, name, inner) {
  return function (dispatch, getState) {
    if (inner) {
      dispatch(_changeOrg(value, name, function () {

      }));
    } else {
      cb.utils.confirm('确定要切换组织吗？该操作将重新刷新页面！', function () {
        dispatch(_changeOrg(value, name, function () {
          clearCache();
          const { userStores } = getState().user.toJS();
          const stores = userStores && userStores.filter(item => {
            return item.org_id === value;
          });
          if (stores && stores.length)
            localStorage.setItem('defaultStore', stores[0].store);
          location.reload();
        }));
      });
    }
  }
}

const _changeOrg = function (value, name, callback) {
  return function (dispatch) {
    const config = {
      url: 'user/changeOrgOrShop',
      method: 'POST',
      params: {
        orgId: value
      }
    }
    proxy(config)
      .then(json => {
        if (json.code !== 200) {
          cb.utils.alert(json.message, 'warning');
          return;
        }
        const info = { defaultOrgName: name, orgId: value };
        Object.assign(cb.rest.AppContext.user, info);
        dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_CHANGE_ORG', info));
        localStorage.setItem('defaultOrg', value);
        callback();
      });
  }
}

export function changeStore(value, name, inner) {
  return function (dispatch, getState) {
    if (inner) {
      dispatch(_changeStore(value, name, function () {
        dispatch(afterStoreLoaded());
      }));
    } else {
      cb.utils.confirm('确定要切换门店吗？该操作将重新刷新页面！', function () {
        dispatch(_changeStore(value, name, function () {
          // dispatch(getGrades());
          // dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_STORE_CHANGED'));
          clearCache();
          const { userStores } = getState().user.toJS();
          const stores = userStores.filter(item => {
            return item.store === value;
          });
          if (stores && stores.length)
            localStorage.setItem('defaultOrg', stores[0].org_id);
          location.reload();
        }));
      });
    }
  }
}

const _changeStore = function (value, name, callback) {
  return function (dispatch) {
    const config = {
      url: 'user/changeOrgOrShop',
      method: 'POST',
      params: {
        storeId: value
      }
    }
    proxy(config)
      .then(json => {
        if (json.code !== 200) {
          cb.utils.alert(json.message, 'warning');
          return;
        }
        const info = { defaultStoreName: name, storeId: value };
        Object.assign(cb.rest.AppContext.user, info);
        dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_CHANGE_STORE', info));
        localStorage.setItem('defaultStore', value);
        callback();
      });
  }
}

const _changeOrgAndStore = function (orgId, orgName, storeId, storeName) {
  return function (dispatch) {
    const config = {
      url: 'user/changeOrgOrShop',
      method: 'POST',
      params: {
        orgId,
        storeId
      }
    }
    proxy(config)
      .then(json => {
        if (json.code !== 200) {
          cb.utils.alert(json.message, 'warning');
          return;
        }
        const info = { defaultOrgName: orgName, orgId, defaultStoreName: storeName, storeId };
        Object.assign(cb.rest.AppContext.user, info);
        dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_MERGE_INFO', info));
        dispatch(afterStoreLoaded());
      });
  }
}

export function changeGrade(value, name) {
  return function (dispatch) {
    const gradeInfo = { defaultGradeName: name, gradeId: value };
    dispatch(genAction('PLATFORM_DATA_USER_ACCOUNT_CHANGE_GRADE', gradeInfo));
    localStorage.setItem('defaultGrade', JSON.stringify(gradeInfo));
  }
}

export function weChatLogin() {
  return function (dispatch) {
    let config = {
      url: '/weChat/getWechatQrCode',
      method: 'GET'
    }
    if (process.env.NODE_ENV === 'development')
      config.params = { debug: true };
    proxy(config)
      .then(json => {
        if (json.code !== 200) {
          cb.utils.alert(json.message, 'warning');
          console.error(json.message)
          return;
        }
        window.open(json.data, '_self');
      })
  }
}

export function switchInterMode(mode) {
  return async function (dispatch) {
    const config = {
      url: 'user/switchInterMode',
      method: 'GET',
      options: { uniform: false },
      params: { mode }
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert(json.message);
      return;
    }
    location.href = json.data.redirectUrl;
  }
}
